import { PropsWithChildren } from 'react';

import styles from './NavTabsContainer.module.css';

export default function NavTabsContainer({ children }: PropsWithChildren) {
  return <div className={styles.navTabs}>{children}</div>;
}
